// EditarUsuario.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import BasicLayout from "../../layauots/BasicLayout";
import { Card } from "react-bootstrap";
import MDBox from "../../controls/MDBox";
import MDTypography from "../../controls/MDTypography";
import MDInput from "../../controls/MDInput";
import { Save } from "react-bootstrap-icons";
import { ExitToApp } from "@mui/icons-material";
import MDButton from "../../controls/MDButton";
import { Alert, AlertTitle, Autocomplete, TextField } from "@mui/material";
import bgImage from "../../../assets/images/bg-sign-up-cover.jpeg";
import { postData } from "../../Utils/Http/api";
import { useUsuarios } from "../../Utils/Usuarios";


const UsuarioParametros = () => {
const { id } = useParams(); // Obtener el parámetro de la URL (el ID del Usuario a editar)
const [Usuario, setUsuario] = useState(null);
const [IdUsuario, setIdUsuario] = useState(null);
const [horaIngreso, setHoraIngreso] = useState("");
const [horaSalida, setHoraSalida] = useState("");
const [nombre, setNombre] = useState("");
const [diasVacaciones, setDiasVacaciones] = useState(0);
const [fechaIngreso, setFechaIngreso] = useState("");
const [nombreboton, setnombreboton] = useState("Cancelar");
const [mensaje, setMensaje] = useState("");
const history = useNavigate();
const [grabando, setGrabando] = useState(false);
const [exito, setExito] = useState(false);
const [selectedValueUsuario, setSelectedValueUsuario] = useState([]);

const [idUsuarioSupervisor, setIdUsuarioSupervisor] = useState(0);
const [elementsUser, setElementsUser] = useState([]);
const [usersFromFuncion, setUsersFromFuncion] = useState([]);
     
const usuarios = useUsuarios();
    const handleVolver = () => {
        history("/UsuarioVolver"); // Cambia '/ruta-de-listado' por la ruta real de tu listado de datos
    };

    useEffect(() => {
        const GetUsuario = async () => {
            try {
                const reqUsuario = {
                    idUsuario: id
                };
                
                const data = await postData("UsuarioParametrosAsyncEvGetByID", reqUsuario);
                console.log("data", data)
                setUsuario(data);
                setIdUsuarioSupervisor(data.idUsuarioSupervisor)
                setNombre(data.usuario);
                setHoraIngreso(data.horaIngreso);
                setHoraSalida(data.horaSalida);
                setDiasVacaciones(data.diasVacaciones);
                setIdUsuario(data.idUsuario)
                setFechaIngreso(data.fechaIngreso && !data.fechaIngreso.startsWith("0001-01-01")
                                ? data.fechaIngreso.split("T")[0]
                                : "");
               
            } catch (error) {
                console.error("Error:", error);
            }
        };
        GetUsuario();
    }, [id]);

const formatDate = (date) => {
        const formattedDate = new Date(date);
        const day = formattedDate.getDate().toString().padStart(2, "0");
        const month = (formattedDate.getMonth() + 1).toString().padStart(2, "0"); // El mes es devuelto de 0 a 11, por eso se le suma 1
        const year = formattedDate.getFullYear();
        return `${day}/${month}/${year}`;
    };
  useEffect(() => {
    const GetUsuarioSupervisor = async () => {
      if (Usuario) {

        setElementsUser(usuarios)

        const defaultValueId = idUsuarioSupervisor; // ID del elemento que deseas seleccionar por defecto
        console.log("defaultValueId", defaultValueId)
        console.log("usuarios", usuarios)
        
        const defaultValue = usuarios.find(
          (item) => item.idUsuario === defaultValueId
        );
        setSelectedValueUsuario(defaultValue);
      }
    };
    GetUsuarioSupervisor();
  }, [Usuario, usuarios]);

  
  const handleAutocompleteUsuarioChange = (event, value) => {
    setSelectedValueUsuario(value);
};

    const formatTime = (time) => {
        // Si no tiene segundos, agregar ":00"
        if (time.split(":").length === 2) {
          return time + ":00"; // Si tiene solo horas y minutos, agregar ":00"
        }
        return time; // Si ya tiene segundos, devolverlo tal como está
      };
    const handleSubmit = async (event) => {

        try {

            setMensaje("");
            setGrabando(true); // Inicia la grabación
            setnombreboton("Volver");
            setExito(true);
            setMensaje('');

            const reqUsuario = {
                idUsuario: id,
                horaIngreso: formatTime(horaIngreso),
                horaSalida: formatTime(horaSalida),
                diasVacaciones: diasVacaciones,
                idUsuarioSupervisor: selectedValueUsuario.idUsuario,
                fechaIngreso : fechaIngreso
            };
            const res = await postData("UsuarioParametrosAsyncModificacion", reqUsuario);

            if (res.isSuccess) {
                // Manejar respuesta exitosa
                setMensaje("¡Datos actualizados exitosamente!");
            } else {
                // Manejar errores si la respuesta no es exitosa
                setMensaje(res.error);
                setGrabando(false); // Inicia la grabación
                setnombreboton("Cancelar");
                setExito(false);
            }
        } catch (error) {
            setMensaje("Error en la solicitud:", error);
            setGrabando(false); // Inicia la grabación
            setExito(false);
            setnombreboton("Cancelar");
            console.log("Error en la solicitud:" + error);
        }
    };

    if (!Usuario) {
        return <BasicLayout image={bgImage}>
            <Card style={{ width: "157%" }}>
                <MDBox
                    variant="gradient"
                    bgColor="warning"
                    borderRadius="lg"
                    coloredShadow="primary"
                    mx={2}
                    mt={-3}
                    p={3}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Cargando Datos de Usuarios...
                    </MDTypography>
                </MDBox>

            </Card>
        </BasicLayout>
    }

    return (
        <BasicLayout image={bgImage}>
            <Card>
                <MDBox
                    variant="gradient"
                    bgColor="warning"
                    borderRadius="lg"
                    coloredShadow="success"
                    mx={2}
                    mt={-3}
                    p={3}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Editar Parametros Usuario
                    </MDTypography>
                    <MDTypography display="block" variant="button" color="white" my={1}>
                        Indicar valores como horario laboral, Dias de Vacaciones....
                    </MDTypography>
                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form">

                        <MDBox mb={2}>
                            <MDInput
                                type="text"
                                name="nombre"
                                required
                                label="Nombre"
                                variant="standard"
                                value={nombre}
                                disabled={true}
                                fullWidth
                            />
                        </MDBox>
                        <MDBox mb={2}>
                            <Autocomplete
                            options={elementsUser}
                            getOptionLabel={(option) =>
                                option.nombre || "Seleccione Usuario Supervisor"
                            }
                            getoptionselected={(option, value) =>
                                option.idUsuario === value.idUsuario
                            }
                            value={selectedValueUsuario || null}
                            onChange={handleAutocompleteUsuarioChange}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                label="Seleccione Usuario Supervisor"
                                variant="outlined"
                                style={{ width: `300px` }}
                                />
                            )}
                            />
                        </MDBox>
                        <MDBox pt={4} pb={3} px={3}>
                            <MDInput
                                type="time"
                                name="horaIngreso"
                                required
                                label="Hora Ingreso"
                                variant="standard"
                                value={horaIngreso}
                                onChange={(e) => setHoraIngreso(e.target.value)}
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </MDBox>
                        <MDBox pt={4} pb={3} px={3}>
                            <MDInput
                                type="time"
                                name="horaSalida"
                                label="Hora Egreso"
                                variant="standard"
                                value={horaSalida}
                                onChange={(e) => setHoraSalida(e.target.value)}
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </MDBox>
                        <MDBox pt={4} pb={3} px={3}>
                            <MDInput
                                type="date"
                                name="fechaIngreso"
                                required
                                label="Fecha Ingreso"
                                variant="standard"
                                value={fechaIngreso}
                                onChange={(e) => setFechaIngreso(e.target.value)}
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </MDBox>
                        <MDBox mb={1} style={{ display: "flex", gap: "16px" }}>
                            <MDInput
                                type="number"
                                name="diasVacaciones"
                                required
                                label="Vacaciones"
                                variant="standard"
                                value={diasVacaciones}
                                onChange={(e) => setDiasVacaciones(e.target.value)}
                                fullWidth
                            />

                        </MDBox>

                        <MDBox mb={1} style={{ display: "flex", gap: "16px" }}>
                            <MDButton
                                onClick={() => {
                                    handleSubmit();
                                }}
                                variant="gradient"
                                color="warning"
                                endIcon={<Save />}
                                disabled={grabando}
                                fullWidth
                            >
                                Grabar
                            </MDButton>

                            <MDButton
                                onClick={() => {
                                    handleVolver();
                                }}
                                variant="gradient"
                                color="warning"
                                endIcon={<ExitToApp />}

                                fullWidth
                            >
                                {nombreboton}
                            </MDButton>
                        </MDBox>
                    </MDBox>

                    {mensaje !== '' && (

                        <Alert severity={exito ? "success" : "error"}>
                            <AlertTitle>{exito ? "Felicitaciones" : "Error"}</AlertTitle>
                            {mensaje}
                        </Alert>
                    )}
                </MDBox>
            </Card>
        </BasicLayout>
    );
};

export default UsuarioParametros;
